"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticatedCirrusProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_oauth_1 = require("@yanzi/react-oauth");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const AuthenticatedCirrusContext_1 = require("../../contexts/AuthenticatedCirrusContext");
const useCirrus_1 = require("../../hooks/useCirrus");
const useCirrusAuthenticationDetails_1 = require("../../hooks/useCirrusAuthenticationDetails");
const CirrusLogin_1 = require("../CirrusLogin");
const useCirrusAccessTokenLogin_1 = require("./useCirrusAccessTokenLogin");
const useCirrusOAuthLogin_1 = require("./useCirrusOAuthLogin");
const useCirrusSessionIdLogin_1 = require("./useCirrusSessionIdLogin");
const useCirrusSessionIdStorage_1 = require("./useCirrusSessionIdStorage");
function AuthenticatedCirrusProvider({ authenticated }) {
    const { clear: clearSocket, host, socket } = useCirrus_1.useCirrus();
    const { isAuthenticated, authenticationMethod, sessionId } = useCirrusAuthenticationDetails_1.useCirrusAuthenticationDetails(socket);
    useSaveCirrusSessionId();
    const [, , clearStoredSessionId] = useCirrusSessionIdStorage_1.useCirrusSessionIdStorage(host);
    const clearAccessTokenInUrl = useClearAccessTokenInUrl();
    const { clear: clearOAuthToken } = react_oauth_1.useOAuth();
    const signOut = react_1.useCallback(() => {
        clearStoredSessionId();
        clearAccessTokenInUrl();
        clearOAuthToken();
        setTimeout(() => clearSocket());
    }, [clearSocket, clearStoredSessionId, clearAccessTokenInUrl, clearOAuthToken]);
    useCirrusSessionIdLogin_1.useCirrusSessionIdLogin();
    useCirrusAccessTokenLogin_1.useCirrusAccessTokenLogin();
    const { isLoading: isValidatingOAuth, error: oauthError } = useCirrusOAuthLogin_1.useCirrusOAuthLogin();
    const value = react_1.useMemo(() => ({
        signOut,
        authenticationMethod,
        sessionId: sessionId,
    }), [signOut, authenticationMethod, sessionId]);
    if (isAuthenticated) {
        return (jsx_runtime_1.jsx(AuthenticatedCirrusContext_1.AuthenticatedCirrusContext.Provider, Object.assign({ value: value }, { children: authenticated }), void 0));
    }
    return jsx_runtime_1.jsx(CirrusLogin_1.CirrusLogin, { isValidatingOAuth: isValidatingOAuth, oauthError: oauthError }, void 0);
}
exports.AuthenticatedCirrusProvider = AuthenticatedCirrusProvider;
function useSaveCirrusSessionId() {
    const { host, socket } = useCirrus_1.useCirrus();
    const [, saveSessionId] = useCirrusSessionIdStorage_1.useCirrusSessionIdStorage(host);
    const { sessionId, authenticationMethod } = useCirrusAuthenticationDetails_1.useCirrusAuthenticationDetails(socket);
    react_1.useEffect(() => {
        if (sessionId && authenticationMethod === 'usernamePassword') {
            saveSessionId(sessionId);
        }
    }, [sessionId, saveSessionId, authenticationMethod]);
}
function useClearAccessTokenInUrl() {
    const location = react_router_dom_1.useLocation();
    const history = react_router_dom_1.useHistory();
    return react_1.useCallback(() => {
        const currentParams = new URLSearchParams(location.search);
        if (currentParams.has(useCirrusAccessTokenLogin_1.ACCESS_TOKEN_URL_PARAM_KEY)) {
            currentParams.delete(useCirrusAccessTokenLogin_1.ACCESS_TOKEN_URL_PARAM_KEY);
            history.replace(Object.assign(Object.assign({}, location), { search: currentParams.toString() }));
        }
    }, [history, location]);
}
//# sourceMappingURL=index.js.map